import * as React from 'react';
import { defaultRender } from 'piral-core';
export const DefaultHost = (props) => (React.createElement("div", { className: "piral-notifications-host", key: "default_notifications" }, props.children));
export const DefaultToast = ({ children }) => defaultRender(children);
//# sourceMappingURL=default.js.map